/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    /**
     * IDataNodeHealth is a wrapper of NodeHealth to propagate to controllers changes in NodeHealth.
     * Reason: http://stackoverflow.com/questions/19744462/update-scope-value-when-service-data-is-changed
     */
    export interface IDataNodeHealth {
        data: INodeHealth;
    }
    
    export interface INodeHealth {
        elementId: string;
        checks: INodeCheck[];
        healthStatus: string;
    }
    
    export interface INodeCheck {
        name: string;
        type: string;
        healthStatus: string;
        notes: string;
        output: string;
        checkId: string;
        timeStamp?: Date;
    }
    
    export interface ITCPPing {
        port: number | string;
        checkName: string;
        networkElementHref: string;
        checkId?: string;
    }
    
    export class NodeHealth implements INodeHealth {
        public elementId: string;
        public checks: INodeCheck[];
        public healthStatus: string;

        public static Empty(): NodeHealth {
            return new NodeHealth();
        }

        constructor() {
            // empty constructor
            this.elementId = '';
            this.checks = [];
        }

        public status(): string {
            return this.translate(this.healthStatus);
        }
        
        private translate(backendStatus: string): string {
            if (backendStatus === 'PASSED')
                return 'ONLINE';
            if (backendStatus === 'FAILING')
                return 'OFFLINE';
            if (backendStatus === 'NOT_CHECKED')
                return 'PENDING';
            else
                return backendStatus;
        }
        
    }
}